/**
 * tooltip__green_question_mark_in_circle__tooltip_on_hover__COMMON_MESSAGE_Search_Tags_VerboseView_Checkbox_react_component.tsx
 *
 * Common message displayed for all usage of
 *
 * "Verbose view:" checkbox for displaying Search Tags Verbose View
 */

import React from "react";

/**
 *
 */
export const tooltip__green_question_mark_in_circle__tooltip_on_hover__COMMON_MESSAGE_Search_Tags_VerboseView_Checkbox_react_component = function (  ) {

    return (
        <>
            <div>
                Display of Search tags under searches.
            </div>
            <div style={ { marginTop: 3 } }>
                Show tag categories and their tags.
            </div>
        </>
    )
}